<template>
  <p
    :class="{
      'notification--error': type === 'error',
      'notification--success': type === 'success'
    }"
    class="notification"
    role="alert"
  >

    {{ text }}

    <button
      aria-label="Benachrichtigung schließen"
      class="notification__button"
      @click="$emit('remove')"
    />

  </p>
</template>

<script>
export default {
  name: 'ANotification',

  props: {
    text: {
      type: String,
      required: true
    },
    timeout: {
      type: Number,
      default: 6000
    },
    type: {
      type: String,
      validator (value) {
        return [
          'error',
          'success'
        ].indexOf(value) >= 0
      }
    }
  },

  mounted () {
    if (this.timeout) {
      setTimeout(() => this.$emit('remove'), this.timeout)
    }
  }
}
</script>

<style scoped>
.notification {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  padding: 6px 10px;

  line-height: 1.4;
  color: #fff;

  background: var(--color-brand);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.notification--error {
  background-color: var(--color-error);
}

.notification--success {
  background-color: var(--color-success);
}

.notification__button {
  width: 16px;
  height: 16px;
  padding: 0;

  background: url("~@/assets/notification-close.svg") center / 100% no-repeat;
  border: 0;
}
</style>
